import { parseBulkResubmitReport } from '../helpers/parseBulkResubmitReport';
import { OpenAPI } from 'app/API';
import type { $OpenApiTs } from 'app/API/models';
import { request } from 'app/API/core/request';
import type { TCall } from 'app/queries/types/TCall';

export const createResubmitBulkAdminJobsMutationFn =
  (call: TCall) =>
  async ({ requestBody, ...query }: $OpenApiTs['/api/admin/jobs-bulk-resubmit']['post']['req']) =>
    parseBulkResubmitReport(
      await call(() =>
        request<unknown>(OpenAPI, {
          method: 'POST',
          url: '/api/admin/jobs-bulk-resubmit',
          body: requestBody,
          query,
          mediaType: 'application/json',
        }),
      ),
      requestBody.ids,
    );
